import Footer from "../Footer";

import FirstComponent from "../FirstComponent";
import FourthComponent from "../FourthComponent";
import SecondComponent from "../SecondComponent";
import ThirdComponent from "../ThirdComponent";
import TryPayBack from "../TryPayBack";

function Home() {
    return (
        <div>
            <FirstComponent />
            <SecondComponent />
            <ThirdComponent />
            <FourthComponent />
            <TryPayBack />
            <Footer />
        </div>
    )
} export default Home;